// ==========================================
// 📢 Blog Social Media Sharing Logic
// ==========================================

function getShareDetails() {
  // 1. Try to get canonical link from DOM if already present and not generic
  const canonical = document.querySelector('link[rel="canonical"]');
  let canonicalHref = canonical ? (canonical.getAttribute("href") || "").trim() : "";
  if (
    canonicalHref &&
    (canonicalHref.includes("@@") ||
      canonicalHref === "https://cognospace.in/" ||
      canonicalHref === "https://cognospace.in")
  ) {
    canonicalHref = "";
  }

  // 2. Extract clean blog slug from window.location.pathname
  // Handles: /slug, /slug.html, /dist/slug.html, etc.
  const pathParts = window.location.pathname.split("/").filter(Boolean);
  const lastPart = pathParts.pop() || "";
  const slug = lastPart.replace(/\.html$/i, "").trim();

  const isLocal =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1" ||
    window.location.protocol === "file:";

  let shareUrl = "";

  if (canonicalHref) {
    shareUrl = canonicalHref;
  } else if (slug && slug !== "index") {
    // Generate the exact live blog URL
    shareUrl = `https://cognospace.in/${slug}`;
  } else if (!isLocal) {
    shareUrl = window.location.href.split("?")[0].split("#")[0];
  } else {
    shareUrl = "https://cognospace.in/";
  }

  // Extract clean blog title
  const headingElem =
    document.querySelector(".blogs-heading h1") ||
    document.querySelector(".blogs-heading .title") ||
    document.querySelector("h1.title") ||
    document.querySelector("h1");

  let shareTitle = "";
  if (headingElem) {
    shareTitle = headingElem.innerText.replace(/\s+/g, " ").trim();
  }
  if (!shareTitle) {
    shareTitle = document.title ? document.title.split("|")[0].trim() : "CognoSpace";
  }

  return { shareUrl, shareTitle };
}

function openSharePopup(url, title, w = 600, h = 480) {
  const screenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
  const screenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

  const width = window.innerWidth || document.documentElement.clientWidth || screen.width;
  const height = window.innerHeight || document.documentElement.clientHeight || screen.height;

  const left = width / 2 - w / 2 + screenLeft;
  const top = height / 2 - h / 2 + screenTop;

  const newWindow = window.open(
    url,
    title,
    `scrollbars=yes, width=${w}, height=${h}, top=${top}, left=${left}, status=no, resizable=yes, toolbar=no`
  );

  if (window.focus && newWindow) {
    newWindow.focus();
  }
  return newWindow;
}

async function copyToClipboard(text) {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (e) {
      // Fallback below
    }
  }

  try {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.setAttribute("readonly", "");
    textarea.style.position = "fixed";
    textarea.style.left = "-9999px";
    textarea.style.top = "-9999px";
    document.body.appendChild(textarea);
    textarea.select();
    const successful = document.execCommand("copy");
    document.body.removeChild(textarea);
    return successful;
  } catch (err) {
    return false;
  }
}

function shareOnFacebook() {
  const { shareUrl } = getShareDetails();
  const fbShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`;
  const popup = openSharePopup(fbShareUrl, "Share on Facebook", 600, 500);
  if (!popup || popup.closed || typeof popup.closed === "undefined") {
    window.open(fbShareUrl, "_blank", "noopener,noreferrer");
  }
}

function shareOnTwitter() {
  const { shareUrl, shareTitle } = getShareDetails();
  const twShareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(shareTitle)}`;
  const popup = openSharePopup(twShareUrl, "Share on Twitter", 600, 450);
  if (!popup || popup.closed || typeof popup.closed === "undefined") {
    window.open(twShareUrl, "_blank", "noopener,noreferrer");
  }
}

async function shareOnInstagram() {
  const { shareUrl, shareTitle } = getShareDetails();

  // If mobile device supporting Web Share API, open native system share dialog (allows Instagram direct share)
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  if (isMobile && navigator.share) {
    try {
      await navigator.share({
        title: shareTitle,
        text: shareTitle,
        url: shareUrl,
      });
      return;
    } catch (err) {
      if (err.name === "AbortError") {
        return; // User cancelled
      }
    }
  }

  // Desktop / Fallback: Copy link and open Instagram web
  await copyToClipboard(shareUrl);
  window.open("https://www.instagram.com/", "_blank", "noopener,noreferrer");

  if (typeof Swal !== "undefined") {
    Swal.fire({
      icon: "success",
      title: "Link Copied!",
      text: "Blog link copied to clipboard. Opening Instagram so you can share it!",
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 4000,
      timerProgressBar: true,
    });
  } else {
    alert("Blog link copied to clipboard! Opening Instagram so you can share it.");
  }
}

function updateBlogShareLinks() {
  const shareBoxes = document.querySelectorAll(".blog_link_box");
  if (!shareBoxes.length) return;

  const { shareUrl, shareTitle } = getShareDetails();

  shareBoxes.forEach((box) => {
    const fbLink = box.querySelector(".link.facebook");
    if (fbLink) {
      fbLink.setAttribute("href", `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`);
      fbLink.setAttribute("target", "_blank");
      fbLink.setAttribute("rel", "noopener noreferrer");
      fbLink.setAttribute("aria-label", "Share this blog on Facebook");
    }

    const twLink = box.querySelector(".link.twitter");
    if (twLink) {
      twLink.setAttribute("href", `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(shareTitle)}`);
      twLink.setAttribute("target", "_blank");
      twLink.setAttribute("rel", "noopener noreferrer");
      twLink.setAttribute("aria-label", "Share this blog on Twitter");
    }

    const igLink = box.querySelector(".link.instagram");
    if (igLink) {
      igLink.setAttribute("href", "https://www.instagram.com/");
      igLink.setAttribute("target", "_blank");
      igLink.setAttribute("rel", "noopener noreferrer");
      igLink.setAttribute("aria-label", "Share this blog on Instagram");
    }
  });
}

// Global click event listener for social share buttons
document.addEventListener("click", (e) => {
  const fbBtn = e.target.closest(".blog_link_box .link.facebook");
  if (fbBtn) {
    e.preventDefault();
    shareOnFacebook();
    return;
  }

  const twBtn = e.target.closest(".blog_link_box .link.twitter");
  if (twBtn) {
    e.preventDefault();
    shareOnTwitter();
    return;
  }

  const igBtn = e.target.closest(".blog_link_box .link.instagram");
  if (igBtn) {
    e.preventDefault();
    shareOnInstagram();
    return;
  }
});

// Initialize on DOM ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", updateBlogShareLinks);
} else {
  updateBlogShareLinks();
}

export { shareOnFacebook, shareOnTwitter, shareOnInstagram, getShareDetails };
